import { Factory } from '@infodata-group/inf-commons';
import { Period } from '../period';
import dayjs from 'dayjs';

export class PeriodFactory implements Factory<Period> {
  build(o: any): Period {
    const period = new Period();
    period.num = o.Num;
    period.closure = o.Closure;
    period.dateStart = dayjs(o.DateBegin, 'DD.MM.YY').toDate();
    period.dateEnd = dayjs(o.DateEnd, 'DD.MM.YY').toDate();
    period.dateStartLabel = dayjs(o.DateBegin, 'DD.MM.YY').format('DD/MM/YYYY');
    period.dateEndLabel = dayjs(o.DateEnd, 'DD.MM.YY').format('DD/MM/YYYY');
    return period;
  }

  getApi(): string {
    return '';
  }
}
